import request from '@/utils/request'

let GiftPackageApi = {
    /*保存礼包*/
    SavePackage(data) {
        return request._post('/shop/plus.giftpackage.giftpackage/saveGift', data);
    },
    /*获取数据*/
    getData(data) {
        return request._post('/shop/plus.giftpackage.giftpackage/getGiftPackage', data);
    },
    /*保存礼包*/
    EditPackage(data) {
        return request._post('/shop/plus.giftpackage.giftpackage/edit', data);
    },
    /*列表*/
    giftpackageList(data) {
        return request._post('/shop/plus.giftpackage.giftpackage/lists', data);
    },
    /*发布礼包*/
    send(data) {
        return request._post('/shop/plus.giftpackage.giftpackage/send', data);
    },
    /*终止礼包*/
    end(data) {
        return request._post('/shop/plus.giftpackage.giftpackage/end', data);
    },
    /*删除*/
    delpackage(data) {
        return request._post('/shop/plus.giftpackage.giftpackage/del', data);
    },
    /*订单*/
    orderlist(data) {
        return request._post('/shop/plus.giftpackage.giftpackage/orderlist', data);
    },
    /*推广二维码*/
    qrcode(data) {
        return request._post('/shop/plus.giftpackage.giftpackage/qrcode', data);
    },
}

export default GiftPackageApi;



// WEBPACK FOOTER //
// ./src/api/giftpackage.js